import React from "react"
import {Accordion, AccordionDetails, AccordionSummary, Typography, Button} from "@mui/material"
import {ExpandMore as ExpandMoreIcon, NoteAdd as CaseSubmittedIcon} from "@mui/icons-material"
import {useNavigate} from "react-router-dom"

import {CustomerCaseSubmittedActivityPayload} from "@indebted/api"

function CaseSubmittedActivity(
	panelId: number,
	{Title, HappenedAt, Payload}: {Title: string; HappenedAt: string; Payload: CustomerCaseSubmittedActivityPayload},
	expanded: boolean,
	handleExpand: (panelID: number) => (event: any, isExpanded: boolean) => void,
	classes: {summary: string; activityContent: string; activityContentLabel: string; activityContentValue: string},
	customerID: string,
) {
	const navigate = useNavigate()

	return (
		<Accordion expanded={expanded} onChange={handleExpand(panelId)}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<CaseSubmittedIcon color="primary" />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
			<AccordionDetails>
				{expanded && (
					<div className={classes.activityContent}>
						<div>
							<Typography className={classes.activityContentLabel}>Case Type:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.CaseType}</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Submitted By:</Typography>
							<Typography className={classes.activityContentValue}>
								{Payload.SubmitterName || Payload.SubmitterType}
							</Typography>
						</div>
						{Payload.SubmitterEmail && (
							<div>
								<Typography className={classes.activityContentLabel}>Agent Email:</Typography>
								<Typography className={classes.activityContentValue}>
									{Payload.SubmitterEmail}
								</Typography>
							</div>
						)}
						<div>
							<Button
								size="small"
								variant="outlined"
								onClick={() => navigate(`/customers/${customerID}/cases?CaseID=${Payload.CaseID}`)}
								sx={{textTransform: "none", fontSize: "0.75rem", fontWeight: 600}}
							>
								See Case
							</Button>
						</div>
					</div>
				)}
			</AccordionDetails>
		</Accordion>
	)
}

export {CaseSubmittedActivity}
